import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "../styleSheets/faqs.css";
import "../styleSheets/buttons.css";
import { useFaqItems } from "../utilities/faqs";

function Faqs() {
  const { t, i18n } = useTranslation("common");
  const { status, faqs } = useFaqItems(i18n.resolvedLanguage ?? i18n.language);
  const activeFaqs = useMemo(
    () => faqs.filter((faq) => faq.active !== false),
    [faqs],
  );

  return (
    <section className="section-faq">
      <h1 className="faq-title">{t("pageBody.faqs.faqsTitle")}</h1>
      {status === "loading" ? (
        <div className="faq-loading">{t("loading")}</div>
      ) : status === "unavailable" ? (
        <div className="faq-error" role="alert">
          {t("errorMessage.failedLoad")}
        </div>
      ) : activeFaqs.length === 0 ? (
        <div className="faq-empty">
          {t("pageBody.faqs.noFaqs")}
        </div>
      ) : (
        <div className="faq-list">
          {activeFaqs.map((faq, idx) => (
            <details key={faq.id ?? `${faq.question}-${idx}`} className="faq-item">
              <summary className="faq-question">{faq.question}</summary>
              <p className="faq-answer">{faq.answer}</p>
              {faq.link && (
                <a
                  href={faq.link}
                  className="faq-link"
                  target={faq.link.startsWith("http") ? "_blank" : undefined}
                  rel={
                    faq.link.startsWith("http")
                      ? "noopener noreferrer"
                      : undefined
                  }
                >
                  {t("learnMore")}
                </a>
              )}
            </details>
          ))}
        </div>
      )}
    </section>
  );
}

export default Faqs;
